export enum AssetDepreciationMethod {
Constant,
Decreasing,
Total,
}
